import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { categories } from 'src/app/shared/classes/categories.model';
import { ApiService } from 'src/app/shared/services/api.service';

declare var $: any;

@Component({
	selector: 'molla-mobile-menu',
	templateUrl: './mobile-menu.component.html',
	styleUrls: ['./mobile-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class MobileMenuComponent implements OnInit, OnDestroy {

	searchTerm = "";
	categories!:categories[];
	categoriesLoaded: boolean = false
	activeTabId = 1;

	private subscr: Subscription;

	constructor(
		private router: Router,
		private apiService: ApiService,
		private cdr: ChangeDetectorRef
	) {
		this.subscr = this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.hideMobileMenu();
			}
		});
	}

	async ngOnInit() {		
		await this.caricaCategorie();
	}

	async caricaCategorie(){
		const fromDb = undefined;
		const params = fromDb || {};
		params.LIVELLO = 1;
		params.lingua = 'IT';

		this.categories = await this.apiService.fetchCategories(params);

		this.categoriesLoaded = true

		this.activeTabId = 1; // forza il primo tab quando i dati sono pronti
		
		this.cdr.markForCheck(); // Forza il refresh del template
	}

	ngOnDestroy(): void {
		this.subscr.unsubscribe();
	}

	submenuToggle(e) {
		const parent: HTMLElement = e.target.closest('li');
		const submenu: HTMLElement = parent.querySelector('ul');

		if (parent.classList.contains('open')) {
			$(submenu).slideUp(300, function () {
				parent.classList.remove('open');
			});
		}
		else {
			$(submenu).slideDown(300, function () {
				parent.classList.add('open');
			});
		}

		e.preventDefault();
		e.stopPropagation();
	}

	hideMobileMenu() {
		document.querySelector('body').classList.remove('mmenu-active');
		document.querySelector('html').removeAttribute('style');
	}

	submitSearchForm(e: any) {
		e.preventDefault();
		this.searchTerm = e.currentTarget.querySelector('.form-control').value;
		this.router.navigate(['/shop/sidebar/list'], { queryParams: { searchTerm: this.searchTerm } });
	}
}
